// extracted by mini-css-extract-plugin
export default {"main":"LoginDialog_main__sca39","rowItem":"LoginDialog_rowItem__09LQa"};